export default __webpack_public_path__ + "static/media/bbl.f2c13bff.svg";